import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  message,
  Space,
  Layout,
} from "antd";
import axiosInstance from "../api/axiosInstance";
import moment from "moment";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";
import { Content } from "antd/es/layout/layout";

const MeetingsList = () => {
  const [meetings, setMeetings] = useState([]);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [selectedAttendees, setSelectedAttendees] = useState([]);

  useEffect(() => {
    fetchMeetings();
    fetchProjects();
    fetchUsers();
  }, []);

  const fetchMeetings = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/meeting");
      setMeetings(res.data);
    } catch (error) {
      message.error("Gagal mengambil data meeting");
    }
    setLoading(false);
  };

  const fetchProjects = async () => {
    try {
      const res = await axiosInstance.get("/referensi/project");
      setProjects(res.data);
    } catch (error) {
      message.error("Gagal mengambil data project");
    }
  };

  const fetchUsersByProject = async (id_project) => {
    if (!id_project) return;

    try {
      const res = await axiosInstance.get(`/assignment/${id_project}`);
      setUsers(res.data); // Hanya user yang memiliki akses ke proyek
    } catch (error) {
      message.error("Gagal mengambil user berdasarkan project");
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await axiosInstance.get("/referensi/user");
      setUsers(res.data);
    } catch (error) {
      message.error("Gagal mengambil data user");
    }
  };

  const handleEditMeeting = async (record) => {
    setCurrentMeeting(record);
    setIsModalVisible(true);
    setLoading(true);

    try {
      // Ambil daftar peserta meeting berdasarkan id_meeting
      const res = await axiosInstance.get(
        `/history-meeting/${record.id_meeting}`
      );
      const attendees = res.data.map((att) => att.id_user); // Ambil hanya ID user
      setSelectedAttendees(attendees);
    } catch (error) {
      message.error("Gagal mengambil data peserta meeting");
    }

    setLoading(false);
  };

  const handleAddOrUpdate = async (values) => {
    try {
      const meetingId = currentMeeting
        ? currentMeeting.id_meeting
        : Math.floor(Date.now() / 1000) + Math.floor(Math.random() * 1000);

      const { attendees, ...meetingData } = values; // Pisahkan attendees dari form data

      const data = {
        id_meeting: meetingId,
        ...meetingData,
        waktu_meeting: values.waktu_meeting.format("YYYY-MM-DD HH:mm:ss"),
      };

      console.log("📢 Data meeting yang akan dikirim:", data);

      let meetingResponse;
      if (currentMeeting) {
        // Update Meeting
        meetingResponse = await axiosInstance.put(
          `/meeting/${currentMeeting.id_meeting}`,
          data
        );
        message.success("Meeting berhasil diperbarui");

        // Hapus peserta meeting lama
        await axiosInstance.delete(
          `/history-meeting/${currentMeeting.id_meeting}`
        );
      } else {
        // Simpan Meeting Baru
        meetingResponse = await axiosInstance.post("/meeting", data);
        message.success("Meeting berhasil ditambahkan");
      }

      if (meetingResponse.data && meetingResponse.data.id_meeting) {
        const savedMeetingId = meetingResponse.data.id_meeting;

        if (selectedAttendees.length > 0) {
          const historyData = selectedAttendees.map((userId) => ({
            id_meeting: savedMeetingId,
            id_user: userId,
            issue: "Belum ada",
            tindak_lanjut: "Belum ada",
            flag_hadir: false,
          }));

          console.log("📢 Data history-meeting:", historyData);
          await axiosInstance.post("/history-meeting", {
            attendees: historyData,
          });
          message.success("Peserta berhasil diperbarui");
        }
      }

      fetchMeetings();
      setIsModalVisible(false);
      setCurrentMeeting(null);
      setSelectedAttendees([]);
    } catch (error) {
      console.error(
        "❌ Gagal menyimpan meeting:",
        error.response?.data || error
      );
      message.error("Gagal menyimpan meeting");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/meeting/${id}`);
      message.success("Meeting berhasil dihapus");
      fetchMeetings();
    } catch (error) {
      message.error("Gagal menghapus meeting");
    }
  };

  const columns = [
    {
      title: "Project",
      dataIndex: "nama_project",
      key: "nama_project",
    },
    {
      title: "Jenis Meeting",
      dataIndex: "jns_meeting",
      key: "jns_meeting",
    },
    { title: "Lokasi / Link", dataIndex: "link_meeting", key: "link_meeting" },
    {
      title: "Waktu",
      dataIndex: "waktu_meeting",
      key: "waktu_meeting",
      render: (text) => moment(text).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "Aksi",
      render: (text, record) => (
        <Space>
          <Button type="primary" onClick={() => handleEditMeeting(record)}>
            Edit
          </Button>
          <Button type="danger" onClick={() => handleDelete(record.id_meeting)}>
            Hapus
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ marginLeft: 260 }}>
        {/* Menyesuaikan lebar sidebar */}
        <AppHeader />
        <Content
          style={{
            margin: "20px",
            padding: "20px",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setCurrentMeeting(null);
              setIsModalVisible(true);
            }}
          >
            Tambah Meeting
          </Button>
          <Table
            columns={columns}
            dataSource={meetings}
            loading={loading}
            rowKey="id_meeting"
          />

          <Modal
            title={currentMeeting ? "Edit Meeting" : "Tambah Meeting"}
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <Form
              initialValues={{
                ...currentMeeting,
                waktu_meeting: currentMeeting
                  ? moment(currentMeeting.waktu_meeting)
                  : null,
                attendees: selectedAttendees, // Pastikan daftar peserta diisi saat edit
              }}
              onFinish={handleAddOrUpdate}
              layout="vertical"
            >
              <Form.Item
                label="Project"
                name="id_project"
                rules={[{ required: true, message: "Pilih project!" }]}
              >
                <Select
                  placeholder="Pilih Project"
                  onChange={(value) => {
                    fetchUsersByProject(value); // Panggil fungsi filter user berdasarkan project
                    setSelectedAttendees([]); // Reset attendees setiap ganti project
                  }}
                >
                  {projects.map((proj) => (
                    <Select.Option
                      key={proj.id_project}
                      value={proj.id_project}
                    >
                      {proj.nama_project}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Jenis Meeting"
                name="jns_meeting"
                rules={[{ required: true }]}
              >
                <Select>
                  <Select.Option value="1">Online</Select.Option>
                  <Select.Option value="2">Offline</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label="Link / Lokasi Meeting" name="link_meeting">
                <Input />
              </Form.Item>
              <Form.Item
                label="Waktu Meeting"
                name="waktu_meeting"
                rules={[{ required: true }]}
              >
                <DatePicker showTime format="YYYY-MM-DD HH:mm" />
              </Form.Item>
              <Form.Item label="Assign Attendants" name="attendees">
                <Select
                  mode="multiple"
                  placeholder="Pilih pengguna untuk menghadiri meeting"
                  value={selectedAttendees}
                  onChange={setSelectedAttendees}
                >
                  {users.map((user) => (
                    <Select.Option key={user.id_user} value={user.id_user}>
                      {user.nama_user} ({user.jabatan_user})
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Button type="primary" htmlType="submit">
                Simpan
              </Button>
            </Form>
          </Modal>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MeetingsList;
